// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"r0-z","subtitle":"s0-z","wrapper":"t0-z","leftArrow":"u0-z","rightArrow":"v0-z"};